// extracted by mini-css-extract-plugin
module.exports = {"popupFooter":"PopupFooter_popupFooter__HB_je"};